import { clsx } from 'js/utils/classNames.util';
import React from 'react';
import { useUnmountAnimation } from './hooks/useUnmountAnimation';

type WithUnmountProps = {
    shouldRender: boolean;
    className: string;
    animationClass: string;
    animationDuration: number;
    animationClassesObject?: Record<string, string>;
}

const withUnmountAnimation = <P extends object>(
    WrappedComponent: React.ComponentType<P>
) => (props: P & WithUnmountProps) => {
        const { shouldRender, className, animationDuration, animationClass, animationClassesObject, ...restProps } = props;
        const { isUnmounting, isVisible } = useUnmountAnimation(shouldRender, animationDuration);

        if (!isVisible) { return null; }

        return (
            <WrappedComponent
                {...(restProps as P)}
                className={clsx([
                    className,
                    isUnmounting ? animationClass : ''
                ])}
                {...(animationClassesObject && isUnmounting && animationClassesObject)}
            />
        );
    };

export default withUnmountAnimation;
